import React from 'react';
import { motion } from 'framer-motion';
import NavigationBar from 'components/ui/NavigationBar';
import Footer from 'components/ui/Footer';
import ProductCategories from './landing-page/components/ProductCategories';

const ProductsPage = () => {
  return (
    <div className="min-h-screen gradient-background-main">
      {/* Navigation Bar */}
      <NavigationBar />
      
      {/* Page Header */}
      <section className="pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-lg text-text-primary mb-6">
              Our Export Products
            </h1>
            <p className="body-lg text-text-secondary max-w-4xl mx-auto">
              Premium agricultural products from Nigeria, carefully sourced and 
              processed to meet international export standards.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Products Section */}
      <ProductCategories />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ProductsPage; 